export * from './qr.interface';
